export * from './qr.interface';
